import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { LocationsRouterStoreSelectors, RouterStoreStates } from '../router';

import { filter, first, map, tap, withLatestFrom } from 'rxjs/operators';
import { AppSettingsStoreActions, AppSettingsStoreStates } from '../app-settings';
import { CategoryType } from '../shared/types';
import { ResolveFn } from '@angular/router';

export const applicationSettingsResolver: (categoryType: CategoryType) => ResolveFn<boolean> = (
  categoryType: CategoryType
) => {
  return () => {
    const routerStore = inject(Store<RouterStoreStates.RouterState>);
    const applicationConfigurationStore = inject(Store<AppSettingsStoreStates.CategoryApplicationSettingState>);

    return routerStore.select(LocationsRouterStoreSelectors.selectCategory(categoryType)).pipe(
      filter((category) => !!category),
      withLatestFrom(routerStore.select(LocationsRouterStoreSelectors.selectBundleId)),
      tap(([category, bundleId]) => {
        // Load app settings for current category and all parent categories recursively
        const allCategories = category.getAllCategories();
        allCategories.forEach((cat) => {
          applicationConfigurationStore.dispatch(
            AppSettingsStoreActions.AppSettingsResolverActions.appSettingsRequested({
              bundleIdentifier: bundleId,
              categoryType: cat.categoryType,
              categoryId: cat.categoryId,
            })
          );
        });
      }),
      map(() => true),
      first()
    );
  };
};
